<script>

    import { location } from 'svelte-spa-router'

    import EnumMethods from '../$methods/enum.methods'

    import MenuMain from '../$layouts/menu.main.svelte'
    import Tabs from '../$components/tabs.svelte'

    import UserWalletsView from './informations.wallets.view.svelte'
    import UserCreditsView from './informations.credits.view.svelte'
    import UserPrepaidsView from './informations.prepaids.view.svelte'
    import UserChargesView from './informations.charges.view.svelte'
    import UserRefundsView from './informations.refunds.view.svelte'
    import UserAccountsView from './informations.accounts.view.svelte'
    import UserFixedpricesView from './informations.fixedprices.view.svelte'
    import UserInvoicesView from './informations.invoices.view.svelte'

    $: $location && (selected = params.tab || 'wallet')

    export let params = {}

    let selected = null

</script>

<MenuMain />

<div class="container">
    <div class="title is-3">Información / { EnumMethods.get(selected) } </div>
    <hr>
    <Tabs bind:selected={selected}
        options={[
            {href: '/informations/wallet', value: 'wallet', text: 'Cartera', icon: 'wallet'},
            {href: '/informations/credits', value: 'credits', text: 'Creditos', icon: 'credit-card'},
            {href: '/informations/charges', value: 'charges', text: 'Cargos', icon: 'money-check-alt'},
            {href: '/informations/refunds', value: 'refunds', text: 'Reembolsos', icon: 'dollar-sign'},
            {href: '/informations/prepaids', value: 'prepaids', text: 'Prepagos', icon: 'shopping-cart'},
            {href: '/informations/fixedprices', value: 'fixedprices', text: 'Precios fijos', icon: 'money-check-alt'},
            {href: '/informations/accounts', value: 'accounts', text: 'Cuentas consumo', icon: 'money-check-alt'},
            {href: '/informations/invoices', value: 'invoices', text: 'Facturas', icon: 'file-invoice-dollar'},
        ]}
    />
    {#if selected === 'wallet'}
        <UserWalletsView />
    {:else if selected === 'credits'}
        <UserCreditsView />
    {:else if selected === 'charges'}
        <UserChargesView />
    {:else if selected === 'refunds'}
        <UserRefundsView />
    {:else if selected === 'prepaids'}
        <UserPrepaidsView />
    {:else if selected === 'accounts'}
        <UserAccountsView />
    {:else if selected === 'fixedprices'}
        <UserFixedpricesView />
    {:else if selected === 'invoices'}
        <UserInvoicesView />
    {/if}
</div>
